import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { ItemNoAndTypeWithOrderedDetails } from "@coworker/apprestructured/src/shared/types/item";
import { useAllAttachedItems } from "@coworker/apprestructured/src/task-management/services/useAllAttachedItems";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import MultipleArticles from "../../../MultipleArticles/MultipleArticles";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useItemsWithPieces } from "@coworker/apprestructured/src/task-management/services/useItemsWithPieces";

export type ArticlesCreatorFragmentConfigProps = {
  field: string;
  maxArticles: number; // Maybe utilize later
};

type ArticlesCreatorFragmentProps = {
  configProps: ArticlesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function ArticlesCreatorFragment({
  configProps,
  commonProps,
}: ArticlesCreatorFragmentProps) {
  const { field /*maxArticles */ } = configProps;
  const { task, taskType } = commonProps;

  const itemNosAndTypeWithOrderedDetails = validateInitialDetailsFieldValue<
    ItemNoAndTypeWithOrderedDetails[]
  >(getByPath(task, field), field, taskType);

  const { items, isFetchingItems } = useAllAttachedItems(
    itemNosAndTypeWithOrderedDetails ?? LOADING
  );

  const itemsWithPieces = useItemsWithPieces(
    items,
    itemNosAndTypeWithOrderedDetails ?? LOADING
  );

  if (isFetchingItems || isLoading(itemsWithPieces)) {
    return <LoadingCreatorFragment />;
  }

  return <MultipleArticles articles={itemsWithPieces} />;
}

export default ArticlesCreatorFragment;
